import { Component, OnInit } from '@angular/core';
import { Icons } from '@vex/icons/icons';
import { HelperService } from '@vex/services/helper.service';
import { MatDialogRef } from '@angular/material/dialog';
import { LayoutService } from '@vex/services/layout.service';

@Component({
  selector: 'elastic-global-kumobot',
  templateUrl: './global-kumobot.component.html',
  styleUrls: ['./global-kumobot.component.scss']
})
export class GlobalKumobotComponent extends Icons implements OnInit {

  isGlobal: boolean = true;
  
  constructor(
    public helperService: HelperService,
    public dialogRef: MatDialogRef<GlobalKumobotComponent>,
    public layoutService: LayoutService
  ) {
    super();
  }

  ngOnInit(): void {}

  onClose() {
    this.dialogRef.close();
    this.helperService.onClose(true);
  }
}
